"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testnet = exports.chainId = void 0;
exports.chainId = '000000000933ea01ad0ee984209779baaec3ced90fa3f408719526f8d77f4943';
exports.testnet = true;
